import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BrandEmail } from '@shared/components/brand-email/brand-email.component';
import { BrandIcon } from '@shared/components/brand-icon/brand-icon.component';
import { BrandMenu } from '@shared/components/brand-menu/brand-menu.component';
import { BrandName } from '@shared/components/brand-name/brand-name.component';
import { Brandify } from '@shared/pipes/brandify.pipe';

@NgModule({
  bootstrap: [],
  declarations: [BrandIcon, BrandMenu, BrandName, BrandEmail, Brandify],
  exports: [BrandIcon, BrandMenu, BrandName, BrandEmail, Brandify],
  imports: [CommonModule, MatIconModule],
  providers: [],
})
export class BrandModule {}
